import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { viewerApi } from 'app/services/edpApiV1/viewer';

type ViewerSubordinates = {
  id: number;
  name: string;
  middleName: string;
  lastName: string;
  organizationId: string;
  roleName: string;
}[];

const initialState = [
  {
    id: 0,
    name: '',
    middleName: '',
    lastName: '',
    organizationId: '',
    roleName: '',
  },
] as ViewerSubordinates;

export const viewerSubordinatesSlice = createSlice({
  name: 'viewer/subordinates',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        viewerApi.endpoints.subordinates.matchFulfilled,
        (state, { payload }: PayloadAction<ViewerSubordinates>) => payload,
      )
      .addMatcher(viewerApi.endpoints.subordinates.matchRejected, () => initialState);
  },
});

const selectViewerSubordinates = (state: RootState) => state.entities.viewer.subordinates;

export const selectors = { selectViewerSubordinates };
export const actions = viewerSubordinatesSlice.actions;
export const reducer = viewerSubordinatesSlice.reducer;
